<template>
    <div>
        <DataRak v-if="islistrak" v-bind:setidoutletserak="setidoutlet" v-on:createrak="showcreaterak"
                 v-on:Edit="showeditrak" v-on:detailrak="showdetailrak" v-on:backtodetail="bactodetailoutlet" ref="listrak"/>
        <CreateRak v-if="iscreaterak" v-bind:setidoutletserak="setidoutlet" v-on:backlistrak="showlistraks"/>
        <EditRak v-if="iseditrak" v-bind:setidoutletserak="setidoutlet" v-bind:dataidrak="datalistrak"
                 v-on:back="showlistraks" ref="editrak"/>
        <DetailRak v-if="isdetailrak" v-bind:setidoutletserak="setidoutlet" v-bind:dataidrak="datalistrak"
                   v-on:back="showlistraks"/>
    </div>
</template>

<script>
    import DataRak from "../../Rak/DataRak";
    import CreateRak from "../../Rak/CreateRak";
    import EditRak from "../../Rak/EditRak";
    import DetailRak from "../../Rak/DetailRak";
    export default {
        name: "SetRak",
        components: {DetailRak, EditRak, CreateRak, DataRak},
        props:['setidoutlet'],
        data(){
            return{
                islistrak:false,
                iscreaterak:false,
                iseditrak:false,
                isdetailrak:false,

                datalistrak:{
                    idrak:'',
                }
            }
        },
        mounted() {
            this.showlistrak()
        },
        methods:{
            showlistrak(){
                this.islistrak=true;
                this.iscreaterak=false;
                this.iseditrak=false;
                this.isdetailrak=false;
            },

            showlistraks(){
                this.islistrak=true;
                this.iscreaterak=false;
                this.iseditrak=false;
                this.isdetailrak=false;
                $('#datarak').show();
                this.getlistrak(true);
            },

            showcreaterak(){
                this.islistrak=true;
                this.iscreaterak=true;
                this.iseditrak=false;
                this.isdetailrak=false;
                $('#datarak').hide()
            },

            showeditrak(idrak){
                this.islistrak=true;
                this.iscreaterak=false;
                this.iseditrak=true;
                this.isdetailrak=false;
                $('#datarak').hide();
                this.datalistrak.idrak=idrak;
            },

            showdetailrak(idrak){
                this.islistrak=true;
                this.iscreaterak=false;
                this.iseditrak=false;
                this.isdetailrak=true;
                $('#datarak').hide();
                this.datalistrak.idrak=idrak;
            },

            bactodetailoutlet(){
              this.$emit('isdetail')
            },

            getlistrak(reset = false){
                this.$refs.listrak.getrak(reset)
                this.backButtonPressed(this.$refs.listrak.back)
            }
        }
    }
</script>

<style scoped>

</style>